import React, {
  createContext,
  useState,
  useContext,
  ReactNode,
  useEffect,
} from "react";
import { PreviewContent } from "../utils/typeConstants";

interface PreviewContextType {
  previewContentData: PreviewContent[];
  setPreviewContentDetails: React.Dispatch<
    React.SetStateAction<PreviewContent[]>
  >;
  addPreviewContent: (newContent: PreviewContent) => void;
  previewContentIds: number[];
  setPreviewContentIds: React.Dispatch<React.SetStateAction<number[]>>;
}

const PreviewContext = createContext<PreviewContextType | undefined>(undefined);

export const PreviewProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [previewContentData, setPreviewContentDetails] = useState<
    PreviewContent[]
  >([]);
  const [previewContentIds, setPreviewContentIds] = useState<number[]>([]);

  const addPreviewContent = (newContent: PreviewContent) => {
    setPreviewContentDetails((prev) => [...prev, newContent]);
  };

  useEffect(() => {
    const ids = previewContentData?.map((content) => content?.previewId);
    //@ts-ignore
    setPreviewContentIds(ids);
  }, [previewContentData]);

  return (
    <PreviewContext.Provider
      value={{
        previewContentData,
        setPreviewContentDetails,
        addPreviewContent,
        previewContentIds,
        setPreviewContentIds,
      }}
    >
      {children}
    </PreviewContext.Provider>
  );
};

export const usePreviewContext = (): PreviewContextType => {
  const context = useContext(PreviewContext);
  if (!context) {
    throw new Error("usePreviewContext must be used within a PreviewProvider");
  }
  return context;
};
